var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldtrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 59.86 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-196.55627%",
    y1: "302.538462%",
    x2: "291.937564%",
    y2: "-197.807692%",
    id: "boldtrail-gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41148C",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7800B1",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A100D0",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C300E8",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC00F9",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA00FF",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F000FF",
    offset: "47%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F000FF",
    offset: "53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F200F6",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F400E2",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F800C6",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00A0",
    offset: "77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0072",
    offset: "82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0037",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "94%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-128.82787%",
    y1: "233.25644%",
    x2: "359.252896%",
    y2: "-266.8589%",
    id: "boldtrail-gradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41148C",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7800B1",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A100D0",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C300E8",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC00F9",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA00FF",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F000FF",
    offset: "47%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F000FF",
    offset: "53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F200F6",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F400E2",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F800C6",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00A0",
    offset: "77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0072",
    offset: "82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0037",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "94%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-7.38845836%",
    y1: "89.6987278%",
    x2: "90.4822812%",
    y2: "-6.277678%",
    id: "boldtrail-gradient3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41148C",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7800B1",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A100D0",
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C300E8",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC00F9",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA00FF",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F000FF",
    offset: "47%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F000FF",
    offset: "53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F200F6",
    offset: "59%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F400E2",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F800C6",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00A0",
    offset: "77%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0072",
    offset: "82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0037",
    offset: "88%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "94%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    offset: "94%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-74, -750)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(74, 750)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#boldtrail-gradient1)",
    points: "21.3247745 15.6246758 21.3247745 15.6246758 17.2669874 19.7405108 21.3247745 19.7405108 21.3247745 19.7405108 24.9096785 19.7405108 24.9096785 23.3686444 24.9096785 23.3686444 24.9096785 27.4753635 28.9764728 23.3686444 28.9764728 23.3686444 28.9764728 19.7405108 28.9764728 15.6246758 24.9096785 15.6246758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#boldtrail-gradient2)",
    points: "21.3247745 32.0242043 21.3247745 32.0242043 17.2669874 36.1445972 21.3247745 36.1445972 21.3247745 36.1445972 24.9096785 36.1445972 24.9096785 39.7727308 24.9096785 39.7727308 24.9096785 43.8794499 28.9764728 39.7727308 28.9764728 39.7727308 28.9764728 36.1445972 28.9764728 32.0242043 24.9096785 32.0242043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,58 L32.5163403,58 C40.4427613,58 47.3378467,52.5076621 49.1978535,44.708998 L59.8579889,0 L0,0 Z M40.0419366,38.5739882 C39.8753016,43.9067976 35.3896679,48.0682122 30.1113922,48.0682122 L10.2503034,48.0682122 L10.2503034,9.05666012 L30.1474214,9.05666012 C35.4932518,9.05666012 40.0599512,13.4824361 40.0464402,18.8927308 C40.0374329,22.9082908 37.2406674,26.8190177 33.8223983,28.3322593 C39.0691485,29.740668 40.1725424,34.4171316 40.0419366,38.5739882 Z",
    id: "Shape",
    fill: "url(#boldtrail-gradient3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldtrail);
export default __webpack_public_path__ + "static/media/boldtrail.2bec8bf9c579bf938e0fcf14f857ac76.svg";
export { ForwardRef as ReactComponent };